<div
  class="config-card"
  [ngClass]="statusClass()"
  [class.clickable]="canOpen()"
  (click)="canOpen() && showPopOver($event)"
>
  <div class="config-inner">
    <div class="status-wrapper" [ngClass]="statusClass()">
      <ion-icon name="settings" class="status-icon"></ion-icon>
    </div>

    <div class="config-label">
      @if (configuration().installed) {
        <p class="status-label">
          <span class="current-config">{{
            'configuration_current' | translate
          }}</span>
        </p>
      }

      <p class="status-label">
        @if (configuration().pending && !configuration().accepted) {
          <span class="date-stamp">{{
            configuration().added | date: 'mediumDate'
          }}</span>
          <span class="meta-text"
            >&bull; {{ 'configuration_awaiting' | translate }}</span
          >
        } @else if (!configuration().pending && configuration().accepted) {
          <span class="date-stamp">{{
            configuration().added | date: 'mediumDate'
          }}</span>
          <span class="meta-text"
            >&bull; {{ 'configuration_acceptedAt' | translate }}
            {{ configuration().acceptedAt | date: 'mediumDate' }}</span
          >
        } @else {
          {{ 'configuration_refused' | translate }}
          <span class="date-stamp date-stamp-plain">{{
            configuration().acceptedAt || configuration().added
              | date: 'mediumDate'
          }}</span>
        }
      </p>

      <p class="config-description">{{ configuration().description }}</p>
    </div>
  </div>
</div>
